import React from 'react';
import { Icon } from '@grafana/ui';

function SceneDragHandle({ className, dragClass }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: `${className} ${dragClass}`,
    style: {
      width: "20px",
      height: "20px",
      cursor: "move"
    }
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: "draggabledots"
  }));
}

export { SceneDragHandle };
//# sourceMappingURL=SceneDragHandle.js.map
